<template>
  <CatalogueSkeleton v-if="isLoading" type="card"/>

  <!-- red o 5xx: se puede reintentar -->
  <div class="catalogueError" v-else-if="isLoadFailure">
    <p>{{ $t('productCatalogue.loadError') }}</p>
    <a class="button accent" @click="$emit('retry')">
      <div class="text">{{ $t('productCatalogue.retry') }}</div>
    </a>
  </div>

  <!-- sin articulos: tanto si la subcategoria existe y esta vacia como si el slug no existe (404) -->
  <div class="catalogueEmpty" v-else-if="!articles.length">
    <p>{{ $t('productCatalogue.empty') }}</p>
    <LocalizedLink class="button accent" :to="$t('routes.products')">
      <div class="text">{{ $t('productCatalogue.viewAll') }}</div>
    </LocalizedLink>
  </div>

  <div class="productCards alignLeft" v-else>
    <router-link
        class="productCard lightBackground"
        :to="{ name: 'ArticleDetails', params: { subcategory: article.subcategory_slug, slug: article.slug, id: article.id } }"
        v-for="article in articles"
        :key="article.id"
    >
      <img :src="imageUrl(article.image)" :alt="article.name" :title="article.name" loading="lazy">

      <div class="texts">
        <div class="title">{{ article.name }}</div>
      </div>

      <div class="badges" v-if="article.novelty || article.featured">
        <div class="badge novelty" v-if="article.novelty">{{ $t('products.novelty') }}</div>
        <div class="badge featured" v-if="article.featured">{{ $t('products.featured') }}</div>
      </div>
    </router-link>
  </div>
</template>

<script>
import { computed } from 'vue'
import LocalizedLink from '@/components/LocalizedLink.vue'
import CatalogueSkeleton from '@/components/catalogue/CatalogueSkeleton.vue'
import useCatalogueImage from '@/composables/useCatalogueImage'

/**
 * Parrilla de articulos de una categoria o subcategoria.
 *
 * Mismo HTML y mismas clases que ArticlesList.vue, pero con el payload plano de
 * los endpoints del catalogo (name, slug, subcategory_slug) en lugar de
 * name[locale] y url[locale].subcategorySlug.
 */
export default {
  name: 'CatalogueArticleGrid',
  components: { LocalizedLink, CatalogueSkeleton },
  props: {
    articles: {
      type: Array,
      default: () => []
    },
    isLoading: {
      type: Boolean,
      default: false
    },
    error: {
      type: Object,
      default: null
    }
  },
  emits: ['retry'],
  setup(props) {
    const { imageUrl } = useCatalogueImage()

    // un 404 no es un fallo de carga: es un listado vacio, y se pinta como tal
    const isLoadFailure = computed(() => {
      if (!props.error) return false

      return props.error.code === 0 || props.error.code >= 500
    })

    return { imageUrl, isLoadFailure }
  }
}
</script>
